import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { BecareService } from './becare.service';
import { TypeManagerService } from './type-manager.service';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class LegacyContentService {

  public contentPanel;
  public defaultEncoding = 'utf-8';

  @Output() setContent = new EventEmitter<string>();
  @Output() setContentUrl = new EventEmitter<string>();
  @Output() setContentParams = new EventEmitter<any>();
  @Output() setComponent = new EventEmitter<[string, any]>();

  constructor(private becare: BecareService, private http: HttpClient,
              private typeManager: TypeManagerService, private dialog: MatDialog) {
  }

  LoadContent(url, reloadpatient = false, postparams?) {
    url = this.becare.url + '/' + url;
    if (url.indexOf('encoding') === -1) {
      // Add utf8 encoding at the end
      if (this.defaultEncoding !== 'utf-8') {
        url = url + ',encoding=utf8';
      }
    }
    if (typeof(postparams) !== 'undefined') {
      this.setContentParams.emit({url, postparams});
    } else {
      // Get call
      try {
        this.setContentUrl.emit(url);
      } catch {
        this.setContent.emit('Error');
      }
    }
  }

  SetComponent(name: string, data?: any) {
    this.setComponent.emit([name, data]);
  }

  OpenDialog(dialogName: string, data?: any, promise = false) {
    if (promise) {
      return new Promise((successCallback, failureCallback) => {
        if (this.typeManager.typeMap(dialogName)) {
          const componentFactory = this.typeManager.typeMap(dialogName);
          const dialogRef = this.dialog.open(componentFactory, data);
          dialogRef.afterClosed().subscribe(result => {
            console.log('The dialog was closed');
            successCallback(true);
          });
        } else {
          failureCallback(false);
        }
      });
    }
    if (this.typeManager.typeMap(dialogName)) {
      const componentFactory = this.typeManager.typeMap(dialogName);
      const dialogRef = this.dialog.open(componentFactory, {
          data: {
          }
      });
      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
      });
    }
  }
}
